const saveFacebookRoot = function () {
  if ($("#fb-root").length) {
    this.fbRoot = $("#fb-root").detach();
  }
};

const restoreFacebookRoot = function () {
  if (this.fbRoot != null) {
    if ($("#fb-root").length) {
      $("#fb-root").replaceWith(this.fbRoot);
    }
    $("body").append(this.fbRoot);
  }
};

const bindFacebookEvents = function () {
  $(document)
    .on("page:fetch", saveFacebookRoot)
    .on("page:change", restoreFacebookRoot)
    .on("page:load", () => (typeof FB !== "undefined" && window.FB !== null ? window.FB.XFBML.parse() : undefined));
  this.fbEventsBound = true;
};

const initializeFacebookSDK = () =>
  window.FB.init({
    status: true,
    cookie: true,
    xfbml: true,
  });

var loadFacebookSDK = function () {
  window.fbAsyncInit = initializeFacebookSDK;
  return $.getScript("//connect.facebook.net/en_US/all.js");
};


$(() => {
  // Facebook
  loadFacebookSDK();
  if (!window.fbEventsBound) {
    return bindFacebookEvents();
  }
});
